/**
 * Reusable update check + modal. Used by admin menu + hero menu + boot.
 */

import { checkForUpdate, applyUpdate, APP_VERSION } from '../core/version.js';
import { toast } from './toast.js';
import { confirm } from './modal.js';

export async function runUpdateCheck({ silent = false } = {}) {
  if (!silent) toast('🔄 Buscando actualizaciones…', { type: 'info', duration: 1500 });
  const r = await checkForUpdate();
  if (!r.ok) {
    if (!silent) toast(`No se pudo verificar: ${r.error}`, { type: 'error' });
    return r;
  }
  if (!r.hasUpdate) {
    if (!silent) toast(`Estás al día · v${r.currentVersion}`, { type: 'success' });
    return r;
  }
  const proceed = await confirm(
    `Disponible: v${r.remoteVersion} (estás en v${r.currentVersion}). ¿Actualizar ahora? La app se recargará.`,
    '✨ Nueva versión disponible'
  );
  if (proceed) {
    toast('Actualizando…', { type: 'info' });
    setTimeout(() => applyUpdate(), 400);
  }
  return r;
}

/**
 * Silent boot check: si hay update, muestra solo un toast con CTA, no modal intrusivo.
 */
export async function silentBootCheck() {
  const r = await checkForUpdate();
  if (r.ok && r.hasUpdate) {
    toast(`✨ v${r.remoteVersion} disponible — Menú → Buscar actualizaciones`, { type: 'info', duration: 6000 });
  }
}

export function versionLine() {
  return `v${APP_VERSION}`;
}
